module.exports = __webpack_public_path__ + "static/media/kaohebiaozhun.3c63a027.png";